import { useCallback, useEffect, useRef, useState } from "react";

import API from "Signups/FamilyRegistration/API";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";

export default function useTurnOffCompletionNotifications() {
  const { state, dispatch } = useFamilyRegistrationContext();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState();
  const isMounted = useRef(true);

  let finishedNotificationRecipients =
    state?.familyRegistrationSettings?.finishedNotificationRecipients?.users;
  const enabledUserIDs = finishedNotificationRecipients.reduce((acc, cur) => {
    if (cur.enabled) {
      acc.push(cur.ID);
    }
    return acc;
  }, []);

  // tracking whether or not component is currently mounted to avoid updating on an unmounted component
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const turnOffCompletionNotifications = useCallback(async () => {
    if (saving) return;
    setSaving(true);
    setError(false);

    const promiseArray = enabledUserIDs.map((ID) => {
      return API.updateSetting({
        setting: "finishedNotificationRecipients",
        adminID: ID,
        value: false,
      }).post();
    });

    try {
      const res = await Promise.allSettled(promiseArray);

      const successfullyUpdatedIDs = res.reduce((acc, cur, i) => {
        if (cur.status === "fulfilled") {
          acc.push(enabledUserIDs[i]);
        }
        return acc;
      }, []);
      if (isMounted.current) {
        setSaving(false);
        dispatch({
          type: "turnOffCompletionNotifications",
          payload: successfullyUpdatedIDs,
        });
      }
      return res;
    } catch (err) {
      setError(err);
      setSaving(false);
      throw Error(err?.message || err || "Error updating setting");
    }
  }, [saving, dispatch, enabledUserIDs]);

  const clearError = useCallback(() => {
    setError(undefined);
  }, []);

  return {
    turnOffCompletionNotifications,
    saving,
    error,
    clearError,
    setError,
  };
}
